import { UploadTask } from "@firebase/storage";
import { EAttachmentType, EAttachmentUploadStatus } from "./../enums";

class AttachmentModel {
  public readonly uid: string;
  public name: string;
  public type: string;
  public realName: string;
  public attachedTo: EAttachmentType;
  public progress: number;
  public url: string;
  public uploadStatus: EAttachmentUploadStatus;
  private _saved: boolean;
  private _uploadTask?: UploadTask;

  constructor(
    uid: string,
    name: string = "",
    realName: string = "",
    type: string = "",
    attachedTo: EAttachmentType = EAttachmentType.CONTRACT,
    progress: number = 0,
    url: string = "",
    uploadStatus = EAttachmentUploadStatus.IDLE,
    saved: boolean = false
  ) {
    this.uid = uid;
    this.name = name;
    this.realName = realName;
    this.type = type;
    this.attachedTo = attachedTo;
    this.progress = progress;
    this.url = url;
    this.uploadStatus = uploadStatus;
    this._saved = saved;
  }

  getExtention() {
    return this.name.split(".").pop();
  }

  getOnlyName() {
    const nameParts = this.name.split(".");
    nameParts.pop();
    return nameParts.join(".");
  }

  setProgress(progress: number) {
    this.progress = progress;
  }

  setUrl(url: string) {
    this.url = url;
  }

  setUploadStatus(status: EAttachmentUploadStatus) {
    this.uploadStatus = status;
  }

  setUploadTask(task?: UploadTask) {
    this._uploadTask = task;
  }

  setIsSaved(save: boolean) {
    this._saved = save;
  }

  isUploading() {
    return this.uploadStatus === EAttachmentUploadStatus.IN_PROGRESS;
  }

  isUploadFailed() {
    return this.uploadStatus === EAttachmentUploadStatus.ERROR;
  }

  isSuccessfullyUploaded() {
    return !this.isUploading() && !this.isUploadFailed();
  }

  isSaved() {
    return this._saved;
  }

  cancelUpload() {
    if (this._uploadTask) {
      this._uploadTask.cancel();
    }
  }

  toSave() {
    return {
      name: this.name,
      type: this.type,
      realName: this.realName,
      attachedTo: this.attachedTo,
      url: this.url,
    };
  }

  static create(uid: string, data: Partial<AttachmentModel>): AttachmentModel {
    return new AttachmentModel(
      uid,
      data.name,
      data.realName,
      data.type,
      data.attachedTo,
      100,
      data.url,
      EAttachmentUploadStatus.FINISHED,
      true
    );
  }

  static createFromFile(
    file: File,
    id: string,
    attachedTo: EAttachmentType
  ): AttachmentModel {
    return new AttachmentModel(
      id,
      file.name,
      `${id}-${file.name}`,
      file.type,
      attachedTo
    );
  }
}

export default AttachmentModel;
